import { createFileRoute } from "@tanstack/react-router";

import LeagueCategories from "@/components/LeagueProfile/LeagueCategories";

const Component = () => {
  const { leagueUuid } = Route.useParams();
  return <LeagueCategories leagueUuid={leagueUuid} />;
};

export const Route = createFileRoute(
  "/gym/$venueUuid/events/series/$leagueUuid/profile/categories",
)({
  component: Component,
});
